export const getHostname = () => window.location.hostname;
